module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p8"
  }, [_vm._v("Para todos los trabajadores de CPRW; estoy muy agradecido de haberlos conocido.")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Para Dominic, el amor de mi vida,")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("sin cuyo apoyo no hubiese podido hacer nada de esto.")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Y para todo el personal de Dreamspinner Press,")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("por todo lo que hacéis para que mis novelas luzcan bien.")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Sois los mejores.")]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0d7b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0